import { ObjectValuesUnionType } from '../../../utils/typing';

export const GROperationUserStatuses = Object.freeze({
  IN: 'IN', // Registere
  OFF: 'OFF', // Not registered
  EXCLUDED: 'EXCLUDED', // Excluded
  FINISHED: 'FINISHED', // Finished race
});
export type GROperationUserStatus = ObjectValuesUnionType<typeof GROperationUserStatuses>;

export const GRRoundUserStatuses = Object.freeze({
  WON: 'WON',
  OPEN: 'OPEN',
  LOCKED: 'LOCKED',
});
export type GRRoundUserStatus = ObjectValuesUnionType<typeof GRRoundUserStatuses>;
